// extracted by mini-css-extract-plugin
export var quillEditor = "_g5-1";
export var variable = "_g5-0";